import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import { PlainText } from '@wordpress/block-editor';
import { escape, unescape } from './utils';
export default function CodeEdit(_ref) {
  var attributes = _ref.attributes,
      setAttributes = _ref.setAttributes,
      className = _ref.className;
  return createElement("div", {
    className: className
  }, createElement(PlainText, {
    value: unescape(attributes.content),
    onChange: function onChange(content) {
      return setAttributes({
        content: escape(content)
      });
    },
    placeholder: __('Write code…'),
    "aria-label": __('Code')
  }));
}
//# sourceMappingURL=edit.js.map